import { ONLY_NOT_NULL, ONLY_NULL } from "@altertec_gparn/client/src/constants/Filters";

export enum DeliveryNoteType {
  RETURN = "RETURN",
  NORMAL = "NORMAL",
}

export const getDeliveryNoteTypeLabel = (statusEnum: DeliveryNoteType): string => {
  switch (statusEnum) {
    case DeliveryNoteType.RETURN:
      return "DEVOLUCIÓN";
    case DeliveryNoteType.NORMAL:
      return "NORMAL";
  }
};

export const getDeliveryNoteTypeOptions = (): { label: string; value: string }[] => {
  return [
    { label: getDeliveryNoteTypeLabel(DeliveryNoteType.RETURN), value: ONLY_NOT_NULL },
    { label: getDeliveryNoteTypeLabel(DeliveryNoteType.NORMAL), value: ONLY_NULL },
  ];
};
